import { createFileRoute } from '@tanstack/react-router'
import { OrganizationDetailPage } from '../../../components/AdminOrganizations/OrganizationDetail'

export const Route = createFileRoute('/admin/organizations/$id/{-$tab}')({
  component: AdminOrganizationDetailRoute,
})

function AdminOrganizationDetailRoute() {
  const { id, tab } = Route.useParams()
  return <OrganizationDetailPage id={id} tab={tab} />
}
